import { getsessioninfojson } from "./getsessioninfojson";
import { ubtoa } from "./ubtoa";

export function SecureBuffer(org, user, theBuffer) {
  var jsonData = {};
  // jsonData['sk'] =  gSessionKey;
  // jsonData['zc'] =  gSessionCounter++;

  getsessioninfojson(jsonData);

  jsonData["org"] = ubtoa(org);
  jsonData["user"] = ubtoa(user);

  jsonData["data"] = theBuffer;

  var s = JSON.stringify(jsonData);
  return s;
}
